module.exports = __webpack_public_path__ + "static/img/prize_show.e9c0711.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/826/prize_show.png
// module id = 502
// module chunks = 1